/* Copyright (c) 2017 Backpack Health LLC */

const SharePhrases = {

  profile: (isMainProfile, profileName) => ({
    title: {
      id: 'profile.shareCardCategory.title.text',
      values: {
        string1: profileName,
      },
    },
  }),

};

export default SharePhrases;
